import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleAlert, Inbox, SearchX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from './button.js';
import { cn } from './cn.js';
const defaultIcon = {
    empty: Inbox,
    'no-results': SearchX,
    error: CircleAlert,
    compact: Inbox,
};
function isAction(action) {
    return typeof action === 'object' && action !== null && 'onClick' in action && 'label' in action;
}
/**
 * The first-class empty, no-results and error state of every list, panel and
 * sheet section. One glyph, a `title` line, one sentence, one button.
 */
export function EmptyState({ variant = 'empty', icon, title, description, action, onClear, onRetry, className, ...props }) {
    const { t } = useTranslation();
    const Icon = icon ?? defaultIcon[variant];
    const compact = variant === 'compact';
    const error = variant === 'error';
    const button = isAction(action) ? (_jsx(Button, { variant: "outline", size: "sm", onClick: action.onClick, children: action.label })) : action != null ? (action) : variant === 'no-results' && onClear ? (_jsx(Button, { variant: "outline", size: "sm", onClick: onClear, children: t('kit.clearFilters') })) : error && onRetry ? (_jsx(Button, { variant: "outline", size: "sm", onClick: onRetry, children: t('kit.retry') })) : null;
    return (_jsxs("div", { role: error ? 'alert' : 'status', "data-slot": "empty-state", "data-variant": variant, className: cn('flex text-muted-foreground', compact
            ? 'flex-row items-center gap-3 px-4 py-6 text-left'
            : 'flex-col items-center justify-center gap-2 px-6 py-10 text-center', className), ...props, children: [_jsx(Icon, { "aria-hidden": "true", className: cn('shrink-0', compact ? 'size-5' : 'size-6 [stroke-width:1.75]', error ? 'text-destructive-text' : 'text-muted-foreground') }), _jsxs("div", { className: cn('flex min-w-0 flex-col gap-1', !compact && 'items-center'), children: [_jsx("h3", { className: "font-display text-readout font-semibold text-foreground", children: title }), description != null && _jsx("p", { className: "max-w-[360px] text-body", children: description })] }), button != null && _jsx("div", { className: cn(!compact && 'mt-2'), children: button })] }));
}
//# sourceMappingURL=empty-state.js.map